import { CostAnomalyAlert } from "../../../../../../../../services/cloudchipr.api";

export const isCostAnomalyAlert = (alert: any): alert is CostAnomalyAlert => {
  return !!alert.view_id;
};
